import React from 'react';

const PlayerRank = ({ rank, name, points, avatar, isTopRank }) => {
  const truncatedName = name.length > 15 ? `${name.substring(0, 15)}...` : name;
  const formattedPoints = points ? points.toLocaleString('en-US') : '0';

  const handleImageError = (e) => {
    e.target.src = 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y';
  };

  if (isTopRank) {
    return (
      <div className="flex items-center justify-between p-4 bg-gradient-to-r from-brand-lime/10 to-brand-terracotta/10 rounded-lg border border-brand-lime">
        <div className="flex items-center space-x-4">
          <span className="text-2xl font-bold text-brand-lime">#{rank}</span>
          <img src={avatar} alt={name} className="w-12 h-12 rounded-full border-2 border-brand-lime" onError={handleImageError} />
          <div>
            <h6 className="font-bold text-white" title={name}>
              {truncatedName}
            </h6>
          </div>
        </div>
        <div className="text-right">
          <span className="text-2xl font-bold text-brand-lime">{formattedPoints}</span>
          <p className="text-sm text-gray-400">poin</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between p-3 hover:bg-brand-gray/30 rounded-lg transition duration-200">
        <div className="flex items-center space-x-3">
            <span className="text-gray-400 font-semibold w-8">#{rank}</span>
            <img src={avatar} alt={name} className="w-10 h-10 rounded-full" onError={handleImageError} />
            <span className="text-white font-medium" title={name}>{truncatedName}</span>
        </div>
        <div className="text-right">
          <span className="text-white font-semibold">{formattedPoints}</span>
          <p className="text-sm text-gray-400">poin</p>
        </div>
    </div>
  );
};

export default PlayerRank;
